import React from 'react';
import {Box} from '@mui/material';

const TabPanel = ({children, value, index, ...other}) => (
    <Box
        role="tabpanel"
        hidden={value !== index}
        id={`expert-tabpanel-${index}`}
        aria-labelledby={`expert-tab-${index}`}
        sx={{flex: 1, overflow: 'auto'}}
        {...other}
    >
        {value === index && children}
    </Box>
);

export default TabPanel;
